import WeatherPulseHome from "./WeatherPulseHome";
import WeatherLive from "./WeatherLive";
import WeatherNow from "./WeatherNow";
import WeatherJournal from "./WeatherJournal";
import WeatherLearn from "./WeatherLearn";
import WeatherMap from "./WeatherMap";
import WeatherPlace from "./WeatherPlace";
import WeatherYear from "./WeatherYear";
import WeatherStation from "./WeatherStation";
import WeatherSchools from "./WeatherSchools";
import SchoolsJournal from "./SchoolsJournal";

/**
 * Weather Pulse route manifest — same docket pattern as farmers_pulse.
 * Embedded paths live under /weather-pulse/*; standalonePath values are the
 * root URLs for the future weatherpulse.in fork.
 */
export const ROUTES = [
  { name: "wp-home", path: "/weather-pulse", standalonePath: "/", element: <WeatherPulseHome /> },
  { name: "wp-live", path: "/weather-pulse/live", standalonePath: "/live", element: <WeatherLive /> },
  { name: "wp-now", path: "/weather-pulse/now", standalonePath: "/now", element: <WeatherNow /> },
  { name: "wp-journal", path: "/weather-pulse/journal", standalonePath: "/journal", element: <WeatherJournal /> },
  { name: "wp-learn", path: "/weather-pulse/learn", standalonePath: "/learn", element: <WeatherLearn /> },
  { name: "wp-map", path: "/weather-pulse/map", standalonePath: "/map", element: <WeatherMap /> },
  { name: "wp-place", path: "/weather-pulse/place", standalonePath: "/place", element: <WeatherPlace /> },
  { name: "wp-365", path: "/weather-pulse/365", standalonePath: "/365", element: <WeatherYear /> },
  { name: "wp-station", path: "/weather-pulse/station", standalonePath: "/station", element: <WeatherStation /> },
  { name: "wp-station-public", path: "/weather-pulse/station/:id", standalonePath: "/station/:id", element: <WeatherStation /> },
  { name: "wp-schools", path: "/weather-pulse/schools", standalonePath: "/schools", element: <WeatherSchools /> },
  { name: "wp-schools-journal", path: "/weather-pulse/schools/journal", standalonePath: "/schools/journal", element: <SchoolsJournal /> },
];

export function toStandalonePath(path, standalonePath) {
  return standalonePath || path.replace(/^\/weather-pulse/, "") || "/";
}
